// Duits (de-DE), family: zelfde vorm als family.nl.ts. Nederlandse diensten (Parro, Magister,
// Voetbal.nl) en feestdagen (Koningsdag) houden hun eigen naam. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const familyDe = {
    nav: {
        wishes: 'Wünsche',
        messages: 'Nachrichten',
        calendars: 'Kalender',
        family: 'Verwandte',
    },
    common: {
        save: 'Speichern',
        saved: 'Gespeichert.',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        remove: 'Entfernen',
        undo: 'Rückgängig',
        copy: 'Link kopieren',
        copied: 'Link kopiert.',
        readOnly: 'Nur lesen',
        everyone: 'Alle',
        loading: 'Wird geladen…',
        retry: 'Erneut versuchen',
        error: 'Etwas ist schiefgelaufen. Versuch es noch einmal.',
        back: 'Zurück',
        close: 'Schließen',
        whoAreYou: 'Wer bist du?',
        readAloud: 'Vorlesen',
        inDays: { one: 'morgen', other: 'in {count} Tagen' },
        today: 'heute',
        turnsAge: 'wird {age}',
        dayOf: 'Tag {index} von {count}',
    },
    wishes: {
        title: 'Wünsche',
        intro: 'Was steht auf den Wunschzetteln? Kinder wählen selbst ein Bild auf dem Tablet.',
        add: 'Wunsch hinzufügen',
        addShort: 'Wunsch',
        listOf: 'Wünsche von {name}',
        editTitle: 'Wunsch bearbeiten',
        newTitle: 'Neuer Wunsch',
        fieldTitle: 'Was ist es?',
        fieldTitleHint: 'Kurz und klar, zum Beispiel Laufrad',
        fieldFor: 'Für wen',
        fieldPicto: 'Bild',
        fieldNote: 'Details',
        fieldNoteHint: 'Größe, Farbe oder Marke (optional)',
        fieldUrl: 'Link zum Shop',
        fieldUrlHint: 'Beginnt mit https:// (optional)',
        fieldPrice: 'Ungefähr (€)',
        fieldPriority: 'Wie sehr?',
        priority1: 'Wäre schön',
        priority2: 'Wäre toll',
        priority3: 'Am allerliebsten',
        received: 'Bekommen',
        markReceived: 'Bekommen',
        fromTablet: 'selbst auf dem Tablet gewählt: sucht zusammen aus, was genau',
        removed: '{title} entfernt.',
        receivedToast: '{title} steht jetzt bei Bekommen.',
        share: 'Teilen',
        shareTitle: 'Liste von {name} teilen',
        shareIntro: 'Alle mit diesem Link können die Liste sehen und etwas abhaken, ohne Konto. {name} sieht nie, wer was kauft.',
        shareCreate: 'Link zum Teilen erstellen',
        shareNew: 'Neuer Link',
        shareNewHint: 'Der alte Link funktioniert danach nicht mehr.',
        shareStop: 'Nicht mehr teilen',
        shareStopped: 'Die Liste wird nicht mehr geteilt.',
        shared: 'Geteilt',
        reveal: 'Verraten',
        revealHint: 'Zeigt, was schon gekauft ist. Achtung: Kinder können mitlesen.',
        claimedBy: '{name} kauft das',
        claimedAnon: 'Jemand kauft das',
        boughtBy: '{name} hat es gekauft',
        boughtAnon: 'Schon gekauft',
        emptyTitle: 'Noch keine Wünsche',
        emptyBody: 'Füge einen hinzu oder lass {name} einen auf dem Tablet wählen.',
        urlInvalid: 'Nutze einen Link, der mit https:// beginnt',
    },
    share: {
        title: 'Wunschzettel von {name}',
        intro: 'Such dir etwas zum Schenken aus. {name} sieht nicht, wer was kauft.',
        claim: 'Ich kaufe das',
        claimTitle: 'Dieses Geschenk übernehmen',
        claimName: 'Dein Name (optional)',
        claimNameHint: 'Damit andere sehen, dass es erledigt ist.',
        claimConfirm: 'Ich kaufe das',
        mine: 'Du kaufst das',
        mineBought: 'Du hast das gekauft',
        bought: 'Gekauft',
        release: 'Doch nicht',
        taken: 'Jemand kauft das schon',
        takenBy: '{name} kauft das schon',
        goneTitle: 'Dieser Link funktioniert nicht mehr',
        goneBody: 'Frag nach einem neuen Link.',
        emptyTitle: 'Die Liste ist noch leer',
        emptyBody: 'Schau später noch einmal vorbei.',
        footer: 'Erstellt mit dem Familienboard von AMUMIN. Kein Konto nötig.',
        toWebshop: 'Im Shop ansehen',
    },
    days: {
        title: 'Kalender',
        intro: 'Geburtstage, Feiertage, Schulferien und verknüpfte Kalender stehen automatisch im Kalender.',
        upcoming: 'Demnächst',
        upcomingEmpty: 'In den nächsten Wochen nichts Besonderes.',
        layers: 'Was steht im Kalender?',
        layerBirthdays: 'Geburtstage',
        layerBirthdaysHint: 'Aus der Familie und von Familien, die ihre Geburtstage teilen.',
        layerHolidays: 'Feiertage',
        layerHolidaysHint: 'Koningsdag, Ostern, Weihnachten und Tage wie Muttertag.',
        layerSchool: 'Schulferien',
        region: 'Region',
        regionNoord: 'Nord',
        regionMidden: 'Mitte',
        regionZuid: 'Süd',
        regionOff: 'Aus',
        regionHint: 'In welcher Region liegt eure Schule? Herbst, Weihnachten, Frühjahr und Mai sind empfohlene Termine.',
        birthdays: 'Geburtstage',
        birthdaysHint: 'Trag ein Geburtsdatum ein, dann steht der Geburtstag im Kalender.',
        birthDate: 'Geburtsdatum von {name}',
        birthDateSaved: 'Der Geburtstag von {name} steht im Kalender.',
    },
    feeds: {
        title: 'Verknüpfte Kalender',
        add: 'Kalender verknüpfen',
        addTitle: 'Kalender verknüpfen',
        intro: 'Hol Schule, Sport und Arbeit automatisch herein. Jede halbe Stunde aktualisiert.',
        provider: 'Woher kommt der Kalender?',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'Andere',
        },
        howto: {
            google: 'Kalendereinstellungen → Kalender integrieren → Privatadresse im iCal-Format.',
            icloud: 'Kalender → Kalender teilen → Öffentlicher Kalender → webcal-Link kopieren.',
            outlook: 'Einstellungen → Kalender → Freigegebene Kalender → Veröffentlichen → ICS-Link.',
            parro: 'Parro → Instellingen → Agenda koppelen → Link kopieren.',
            magister: 'Magister → Agenda → Agenda delen → Link kopieren.',
            sportlink: 'Voetbal.nl → Programma → Zet in je agenda → iCal-Link kopieren.',
            other: 'Jeder Link, der auf .ics endet oder mit webcal:// beginnt, funktioniert.',
        },
        url: 'Link',
        urlHint: 'Beginnt mit webcal:// oder https://',
        name: 'Name',
        namePlaceholder: 'Zum Beispiel Schule',
        forWho: 'Für wen',
        forWhoHint: 'Niemand gewählt = alle.',
        review: 'Unbekannte Einträge zuerst zeigen',
        reviewHint: 'Praktisch bei einem Schulkalender für mehrere Kinder.',
        rules: 'Regeln',
        rulesHint: 'Steht das im Titel? Dann gehört es zu…',
        ruleContains: 'Text',
        rulePlaceholder: 'zum Beispiel Klasse 3',
        addRule: 'Regel hinzufügen',
        connect: 'Verknüpfen',
        connected: '{name} ist verknüpft: {count} Termine.',
        refresh: 'Jetzt aktualisieren',
        refreshed: 'Aktualisiert.',
        remove: 'Trennen',
        removeConfirm: 'Kalender {name} trennen? Die Termine daraus verschwinden aus eurem Kalender.',
        removed: '{name} ist getrennt.',
        statusOk: 'Aktualisiert {ago}',
        statusNew: 'Noch nicht abgerufen',
        statusStale: 'Veraltet: seit einem Tag nicht erreichbar',
        statusError: 'Fehlgeschlagen: {error}',
        items: { one: '{count} Termin', other: '{count} Termine' },
        reviewCount: 'Unbekannt ({count})',
        reviewTitle: 'Für wen ist das?',
        reviewIntro: 'Wähle für jeden Termin, für wen er ist. Das bleibt so, auch nach dem Aktualisieren.',
        hide: 'Ausblenden',
        assign: 'Zuweisen',
        readonlyNote: 'Titel und Zeit kommen aus dem verknüpften Kalender.',
        emptyTitle: 'Noch kein Kalender verknüpft',
        emptyBody: 'Hol Schule, Sport und Arbeit automatisch herein.',
    },
    links: {
        title: 'Verwandte und Freunde',
        intro: 'Verbinde Oma und Opa, den anderen Elternteil oder Freunde. Ihr entscheidet selbst, was ihr teilt.',
        add: 'Verwandte verbinden',
        addTitle: 'Verwandte verbinden',
        codeHave: 'Code bekommen?',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'Ansehen',
        kind: 'Wer ist es?',
        kinds: {
            grandparents: 'Oma und Opa',
            coparent: 'Anderer Elternteil',
            family: 'Verwandte',
            friends: 'Freunde',
        },
        label: 'Wie nennt ihr sie?',
        labelPlaceholder: 'Zum Beispiel Oma und Opa Schneider',
        via: 'Wie einladen?',
        viaEmail: 'Per E-Mail',
        viaCode: 'Mit einem Code',
        email: 'E-Mail-Adresse',
        share: 'Was teilt ihr?',
        scopeAgenda: 'Kalender von',
        scopeAgendaHint: 'Nur die Termine der Kinder, die du wählst.',
        scopeBirthdays: 'Geburtstage',
        scopeWishlists: 'Wunschzettel',
        scopeContact: 'Kontaktdaten',
        scopeMessages: 'Nachrichten',
        scopeMessagesHint: 'Sie können bei Gesprächen mitmachen, zu denen ihr sie hinzufügt.',
        invite: 'Einladen',
        invited: 'Einladung an {email} gesendet.',
        codeReady: 'Gib diesen Code an {label}',
        codeValid: 'Gültig bis {date}. Sie geben ihn bei Verwandte → Code bekommen? ein.',
        weShare: 'Wir teilen',
        theyShare: 'Sie teilen',
        nothing: 'noch nichts',
        statusPending: 'eingeladen',
        statusActive: 'verbunden',
        statusRevoked: 'getrennt',
        statusEnded: 'von ihnen getrennt',
        expires: 'läuft ab am {date}',
        view: 'Ansehen',
        adjust: 'Anpassen',
        revoke: 'Trennen',
        revokeInvite: 'Zurückziehen',
        remove: 'Entfernen',
        guestMoreDays: 'Noch {count} Tage zeigen',
        endedHint: 'Sie haben die Verbindung beendet. Entferne sie hier; neu verbinden geht jederzeit.',
        revokeConfirm: 'Verbindung mit {label} trennen? Ihr seht danach nichts mehr voneinander.',
        revoked: 'Verbindung getrennt.',
        previewTitle: '{name} möchte sich verbinden',
        previewShares: 'Sie teilen mit euch:',
        accept: 'Verbinden',
        accepted: 'Verbunden mit {name}. Wähle unten, was ihr zurück teilt.',
        acceptLabel: 'Wie nennt ihr sie?',
        inviteGone: 'Diese Einladung gibt es nicht (mehr) oder sie wurde schon benutzt.',
        linkGoneTitle: 'Dieser Link funktioniert nicht mehr',
        linkGoneBody: 'Frag nach einem neuen Code oder gib ihn unten ein.',
        toFamily: 'Zu Verwandte',
        emailMismatch: 'Diese Einladung ist für eine andere E-Mail-Adresse.',
        alreadyLinked: 'Ihr seid schon verbunden.',
        contactTitle: 'Unsere Kontaktkarte',
        contactHint: 'Nur sichtbar für Familien, mit denen du Kontaktdaten teilst.',
        address: 'Adresse',
        phone: 'Telefon',
        contactEmail: 'E-Mail',
        note: 'Notiz',
        emptyTitle: 'Noch niemand verbunden',
        emptyBody: 'Verbinde Oma und Opa: Sie sehen Geburtstage und Wünsche und können Nachrichten schicken.',
        guestTitle: '{name}',
        guestNothing: 'Noch nichts geteilt',
        guestNothingBody: 'Sie entscheiden selbst, was sie zeigen.',
        guestAgenda: 'Kalender (14 Tage)',
        guestBirthdays: 'Bald Geburtstag',
        guestWishes: 'Wünsche',
        guestContact: 'Kontakt',
        guestNoEvents: 'Keine Termine in den nächsten zwei Wochen.',
    },
    messages: {
        title: 'Nachrichten',
        intro: 'Sicher: nur die Familie und Familien, die ihr verbindet. Keine Werbung, keine Algorithmen.',
        parentsReadAll: 'Eltern lesen alle Gespräche mit, auch die der Kinder.',
        family: 'Familie',
        add: 'Gespräch',
        addTitle: 'Neues Gespräch',
        fieldTitle: 'Name des Gesprächs',
        fieldTitlePlaceholder: 'Zum Beispiel Oma und Opa',
        fieldWho: 'Wer macht mit?',
        fieldLinks: 'Verbundene Familien',
        fieldLinksHint: 'Nur Familien, mit denen ihr Nachrichten teilt.',
        create: 'Gespräch starten',
        placeholder: 'Schreib eine Nachricht…',
        send: 'Senden',
        stickers: 'Sticker',
        record: 'Aufnehmen',
        recording: 'Nimmt auf… tippen zum Stoppen',
        voice: 'Sprachnachricht',
        play: 'Abspielen',
        hidden: 'Nachricht von einem Elternteil ausgeblendet',
        hide: 'Ausblenden',
        fromLinked: 'Von verbundenen Familien',
        pickConversation: 'Wähle ein Gespräch',
        emptyTitle: 'Noch keine Nachrichten',
        emptyBody: 'Fang im Familiengespräch an.',
        kidEmptyBody: 'Schick einen Sticker!',
        newMessages: 'neue Nachrichten',
        noMember: 'Verknüpfe dein Login zuerst mit einem Familienmitglied, um Nachrichten zu senden.',
        sticker: 'Sticker',
    },
    phrase: {
        love: 'Ich hab dich lieb',
        comeHome: 'Kommst du nach Hause?',
        hungry: 'Ich hab Hunger',
        done: 'Fertig!',
        miss: 'Ich vermisse dich',
        play: 'Kommst du spielen?',
    },
    wishPicto: {
        gift: 'Geschenk',
        play: 'Kuscheltier',
        puzzle: 'Puzzle',
        drawing: 'Malsachen',
        crafts: 'Bastelsachen',
        reading: 'Buch',
        gaming: 'Spielkonsole',
        cycling: 'Fahrrad',
        soccer: 'Fußball',
        skating: 'Inliner',
        swimming: 'Schwimmsachen',
        dance: 'Tanzkurs',
        'music-lesson': 'Musikunterricht',
        guitar: 'Gitarre',
        piano: 'Klavier',
        drums: 'Schlagzeug',
        unicorn: 'Einhorn',
        dino: 'Dinosaurier',
        rocket: 'Rakete',
        bear: 'Bär',
        rabbit: 'Hase',
        cat: 'Katze',
        dolphin: 'Delfin',
        butterfly: 'Schmetterling',
        rainbow: 'Regenbogen',
        sunflower: 'Blumen',
        'ice-cream': 'Eis',
        pizza: 'Pizza',
        popcorn: 'Popcorn',
        cinema: 'Ins Kino',
        zoo: 'In den Zoo',
        museum: 'Ins Museum',
        camping: 'Zelten',
        sleepover: 'Übernachten',
        party: 'Party',
        trophy: 'Pokal',
    },
    kiosk: {
        wishesEntry: 'Wünsche',
        messagesEntry: 'Nachrichten',
        myWishes: 'Meine Wünsche',
        newWish: 'Neuer Wunsch',
        pickPicture: 'Wähle ein Bild',
        howMuch: 'Wie sehr wünschst du es dir?',
        addToList: 'Auf meine Liste',
        removeAsk: 'Entfernen?',
        wishAdded: 'Steht auf deiner Liste!',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'Steht auf deiner Liste',
        noWishes: 'Noch keine Wünsche',
        noWishesBody: 'Tippe auf das Plus und wähle ein Bild.',
        conversations: 'Gespräche',
        unread: { one: '{count} neu', other: '{count} neu' },
        wishRemoved: '{title} ist weg',
        messageSent: 'Gesendet',
        oops: 'Hoppla',
        typeOwn: 'Selbst tippen',
        typeLabel: 'Deine Nachricht',
        typePlaceholder: 'Was möchtest du sagen?',
        send: 'Senden',
        closeTyping: 'Fertig mit Tippen',
        notYou: 'Nicht du?',
        newMessages: 'Neue Nachrichten',
        alreadyOnList: 'Steht schon auf deiner Liste!',
        alreadyOnListCalm: 'Steht schon auf deiner Liste',
        morePictures: 'Mehr Bilder',
        morePhrases: 'Mehr Sätze',
    },
};
//# sourceMappingURL=family.de.js.map